import {hushiCheckInstall, hushiCheckIsRun, hushiRun} from "../video/hushi";
import {getENV} from "@/common/lib/utils";

export const hushiMixin = {
    methods: {
        /**
         * 开启互视客户端
         * @returns {Promise<void>}
         */
        async runHUshi() {
            if (await this.checkCanOpen()) {
                this.$message.success('客户端正在启动...');
                const uid = await this.uid();
                const obj = await this.create(uid);
                /*if (obj.message === '程序执行成功') {
                  location.href = obj.data.teacherPcRoomUrl.replace('Live3t', 'ConfService');
                }*/
                if (code === 1) {
                    let {code: c, data: d, message: m} = await this.into({
                        classId: data.classId,
                        uid,
                        nickName: 'wyh1'
                    });
                    if (c === 1) {
                        hushiRun({UID: d.UID, classId: d.classId, safeKey: d.safeKey, timeStamp: d.timeStamp});
                    }
                }
            }
        },
        /**
         * 检查是否可以打开互视客户端
         * @returns {Promise<void>}
         */
        async checkCanOpen() {
            if (await this.checkInstall()) {
                if (await this.checkRunning()) {
                    this.$message.error('客户端正在运行中');
                    return false;
                } else {
                    return true;
                }
            } else {
                this.$message.error('客户端未安装或服务未启动');
                return false;
            }
        },

        /**
         * 是否安装
         * @returns {Promise<boolean>}
         */
        async checkInstall() {
            try {
                const {result} = await hushiCheckInstall();
                return result === 0;
            } catch (e) {
                return false;
            }
        },

        /**
         * 是否正在运行
         * @returns {Promise<boolean>}
         */
        async checkRunning() {
            try {
                const {message} = await hushiCheckIsRun();
                if (message === '程序未运行') return false;
                return true;
            } catch (e) {
                return false;
            }
        },


        /**
         * 唤起客户端
         * @param UID
         * @param safeKey
         * @param timeStamp
         * @param classId
         */
        async call({UID, safeKey, timeStamp, classId}) {
            if (await this.checkCanOpen()) {
                this.$message.success('客户端正在启动...');
                hushiRun({UID, safeKey, timeStamp, classId});
            }
        },

        /**
         * 新版互视
         * @param classId
         * @param userId
         * @param userName
         * @param joinRole
         */
        callV2({classId, userId, userName, joinRole}) {
            window.open(getENV().hushi + '/h5-test/#/login?serial=' + classId + '&userid=' + userId + '&username=' + userName + '&invisible=0&joinRole=' + joinRole)
        }
    }
};
